import { APOLLO_CLIENT_SIDE_OPTIONS } from '@/lib/apollo/clients/apolloClient.client'
import type { QueryHookOptions } from '@apollo/client'
import { useQuery } from '@apollo/client'
import {
  GetTenantBySlugDocument,
  type GetTenantBySlugQuery,
  type GetTenantBySlugQueryVariables,
} from '@gql-generated/graphql'

type UseTenantIdOptions = StrictOmit<
  QueryHookOptions<GetTenantBySlugQuery, GetTenantBySlugQueryVariables>,
  'variables'
>

export function useTenantId(options: UseTenantIdOptions = {}) {
  const { data } = useQuery(GetTenantBySlugDocument, {
    ...APOLLO_CLIENT_SIDE_OPTIONS,
    ...options,
    variables: { slug: process.env.NEXT_PUBLIC_BRAND || '' },
  })

  return data?.CMS_Tenants?.docs[0]?.id
}
